module.exports = __webpack_public_path__ + "img/mouse2.1da21a77.svg";